import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBX81XuZ8TpQ_f_FCTBNUIvR_vme7g7Cxs",
  authDomain: "jagahdekho-ec4b0.firebaseapp.com",
  projectId: "jagahdekho-ec4b0",
  storageBucket: "jagahdekho-ec4b0.appspot.com",
  messagingSenderId: "478194674542",
  appId: "1:478194674542:web:8deca57de1aa448e572f7f",
  measurementId: "G-RSDSYN7FZ5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
export { auth, provider };
